import { Component, Injector, Input, OnInit } from '@angular/core';
import { AlertService, ApiCollection, AuthenticationService, ChassisFormHandler, Collection, ModalService, Model, TenantModel, trans } from '@kaiser-software/chassis-core';
import { SelectCustomerModal } from '../../modals/select-customer/select-customer.modal';
import { KpiSetModel } from '../../models/kpi-set.model';
import { Subject } from 'rxjs/Subject';
import { KpiSetTenantService } from '../../services/kpi-set-tenant.service';

@Component({
    selector: 'app-customer-list-plugin',
    templateUrl: 'customer-list.plugin.html',
    styleUrls: [ 'customer-list.plugin.scss' ]
})
export class CustomerListPlugin implements OnInit {

    public items: Collection = new Collection();

    /**
     * New added items in create mode
     */
    public newItems: Array<Model> = [];

    /**
     * Chassis form handler instance injected by the plugin
     * slot, containing the form handler from the page.
     */
    @Input() public form: ChassisFormHandler;

    /**
     * Observable containing the page's model instance.
     */
    @Input() public model: Subject<Model>;

    private modals: ModalService;

    private alerts: AlertService;

    private kpiSetTenantService: KpiSetTenantService;

    private auth: AuthenticationService;

    constructor(injector: Injector) {
        this.modals              = injector.get(ModalService);
        this.alerts              = injector.get(AlertService);
        this.kpiSetTenantService = injector.get(KpiSetTenantService);
        this.auth                = injector.get(AuthenticationService);
    }

    ngOnInit() {
        this.model.subscribe((model: KpiSetModel) => {
            if (model.exists()) {
                this.kpiSetTenantService.defaultParams = { id: model.id };
                this.kpiSetTenantService.all().subscribe((items: ApiCollection) => {
                    this.items = new Collection(items.all());
                    console.log('list', this.items);
                });
            } else {
                this.form.success((model: KpiSetModel, resolve, reject) => {
                    this.kpiSetTenantService.defaultParams = { id: model.id };
                    this.postItemsAfterParentCreated(resolve, reject);
                });
            }
        });
    }

    /**
     * Post all items after the model in the main form has
     * been created.
     *
     * @param resolve
     * @param reject
     */
    private postItemsAfterParentCreated(resolve, reject) {
        if (!this.items.length) {
            resolve();
            return;
        }

        this.newItems.forEach((userModel: TenantModel, index: number) => {
            this.saveCustomer(userModel).then(() => {
                if (index === this.newItems.length - 1) {
                    resolve();
                }
            }, (error) => {
                reject(error);
            });
        });
    }

    /**
     * Open the add modal.
     */
    public openAddCustomerModal() {
        const modal = this.modals.open(SelectCustomerModal, {}, { 'classes': 'slide-top' });

        modal.beforeClose((resolve, reject, item) => {
            item = this.kpiSetTenantService.make(item);

            this.model.subscribe((model: Model) => {
                if (model.exists()) {
                    this.saveCustomer(item).then((result) => {
                        resolve(item);
                    }, (error) => {
                        reject(error);
                    });
                } else {
                    resolve(item);
                }
            }, (error) => {
                reject(error);
            });
        });

        modal.result.then((tenant: TenantModel) => {
            this.model.subscribe((model: Model) => {
                console.log(tenant);
                if (!model.exists()) {
                    this.newItems.push(tenant);
                }

                this.items.push(tenant);
            });
        }, (reason) => {
        });
    }

    /**
     * Save an user.
     *
     * @param {Model} user
     * @return {Promise<any>}
     */
    public saveCustomer(account: Model): Promise<any> {
        return new Promise((resolve, reject) => {
            account.save().subscribe((result) => {
                resolve(result);
            }, (error) => {
                reject(error);
            });
        });
    }

    /**
     * Open the remove confirmation alert.
     *
     * @param customer
     */
    public openRemoveCustomerAlert(customer) {
        const prompt = this.alerts.open({
            title: trans('Are you sure?'),
        });

        prompt.beforeClose((resolve: Function, reject: Function, result: any) => {
            return this.beforeCloseCallback(resolve, reject, result, customer);
        });

        prompt.result.then(() => {
            console.log('result?');
            this.items = this.items.filter((item) => {
                return item !== customer;
            });
        }, () => {

        });
    }

    /**
     * Deletes the customer from the email settings customer list.
     *
     * @param resolve
     * @param reject
     * @param result
     * @param customer
     */
    private beforeCloseCallback(resolve: Function, reject: Function, result: any, customer: TenantModel) {
        if (customer.exists()) {
            // check if new added account in create mode or edit mode
            if (!this.newItems.length || !this.newItems.find((item) => item === customer)) {
                customer.delete().subscribe(() => {
                    resolve(result);
                }, (error) => {
                    reject(error);
                });
            } else {
                resolve(result);
            }
        }
    }


}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/kpis/plugins/customer-list/customer-list.plugin.ts